import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Game from '@/components/Game'
import Result from '@/components/Result'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Top', component: Top },
    { path: '/game', name: 'Game', component: Game },
    { path: '/result', name: 'Result', component: Result }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js